import {Injectable} from '@angular/core';
import {AuthorizationService} from './authorization.service';
import { TokenService } from './token.service';

@Injectable()
export class LocalizationService {

  constructor(private authorizationService: AuthorizationService, private tokenService: TokenService) {}

  public getStartingLanguage() {
    let result = 'en-US'; // navigator.language;
    if (this.tokenService.getCulture()) {
      result = this.tokenService.getCulture();
    }
    return result;
  }

  public getLanguangeForZendesk(): string{
    if(this.tokenService.getCulture()){
      switch(this.tokenService.getCulture().toLowerCase()){
        case 'nl-be':
        case 'nl-nl':
          return 'nl';
        case 'de':
          return 'de';
        case 'fr':
          return 'fr-fr';
        default:
          return 'en-gb';
      }
    }
  }
}
